import documentModel from "./documentModelService";
import { tryLoadProperties } from "@/util/wordUtil";
import { SECTION, TAG, CONTENT_BLOCK, REPEATING_CONTENT_BLOCK, REPEATING_TABLE_BLOCK, HTML_CONTENT_BLOCK } from "@/constants/contentControlTypes";
import { Section, Tag, RepeatingContentBlock, RepeatingTableBlock, HtmlContentBlock, ContentBlock } from "@/models/documentModel";

const hasParent = (context, contentControl) => new Promise(resolve => {
    const parent = contentControl.parentContentControlOrNullObject;
    tryLoadProperties(context, parent, "isNull").then(success => {
        if (success && !parent.isNull) {
            resolve(true);
        } else {
            resolve(false);
        }
    });
})

const getRootControls = async (context, contentControls) => {
    const rootControls = [];

    for (let i = 0; i < contentControls.length; i++) {
        if (!await hasParent(context, contentControls[i])) {
            rootControls.push(contentControls[i]);
        }
    }

    return rootControls;
}

const extractData = async (context, contentControl, parentControl) => {
    if (await tryLoadProperties(context, contentControl, "id", "title", "tag")) {
        var match = /^Sharedo (?<type>\S+): (?<displayName>.+)$/g.exec(contentControl.title);
        if (match) {
            const id = contentControl.id;
            const parentId = !!parentControl ? parentControl.id : null;
            const type = match.groups.type;
            const displayName = match.groups.name;
            const tag = contentControl.tag;

            return {
                id,
                parentId,
                type,
                displayName,
                tag
            };
        }
    }

    return null;
}

const getContentControlObject = (data, oldModel) => {
    const oldObject = oldModel.findContentControl(data.id);
    const displayRuleId = !!oldObject ? oldObject.displayRuleId : "";
    const version = !!oldObject ? oldObject.version : "";
    const label = !!oldObject ? oldObject.label : "";

    let newObject = null;
    switch (data.type) {
        case SECTION:
            newObject = new Section(data.id, data.tag, displayRuleId);
            break;
        case TAG:
            newObject = new Tag(data.id, data.tag, displayRuleId);
            break;
        case REPEATING_CONTENT_BLOCK:
            newObject = new RepeatingContentBlock(data.id, data.tag, displayRuleId);
            break;
        case REPEATING_TABLE_BLOCK:
            newObject = new RepeatingTableBlock(data.id, data.tag, displayRuleId);
            break;
        case HTML_CONTENT_BLOCK:
            newObject = new HtmlContentBlock(data.id, data.tag, label, version);
            break;
        case CONTENT_BLOCK:
            newObject = new ContentBlock(data.id, data.tag, label, version, displayRuleId);
            break;
    }

    return newObject;
}

const processData = (data, newModel, oldModel) => {
    const controlObj = getContentControlObject(data, oldModel);
    if (controlObj) {
        if (data.parentId) {
            var parent = newModel.findContentControl(data.parentId);
            parent.contentControls.push(controlObj);
        } else {
            newModel.contentControls.push(controlObj);
        }
    }
}

const scanContentControls = async (context, contentControls, parentControl, newModel, oldModel) => {
    for (let i = 0; i < contentControls.length; i++) {
        const contentControl = contentControls[i];
        const data = await extractData(context, contentControl, parentControl);

        if (data) {
            processData(data, newModel, oldModel);
        }

        if (await tryLoadProperties(context, contentControl, "contentControls")) {
            const children = contentControl.contentControls;

            if (await tryLoadProperties(context, children, "items")) {
                await scanContentControls(context, children.items, contentControl, newModel, oldModel);
            }
        }
    }
}

const rebuild = async (oldModel) => {
    const newModel = documentModel.create();

    newModel.businessRules = [...oldModel.businessRules];

    await Word.run(async context => {
        const document = context.document;

        if (await tryLoadProperties(context, document, "contentControls")) {
            const contentControlCollection = document.contentControls;

            if (await tryLoadProperties(context, contentControlCollection, "items")) {
                const rootControls = await getRootControls(context, contentControlCollection.items);
                await scanContentControls(context, rootControls, null, newModel, oldModel);
            }
        };
    });

    return newModel;
}

export default {
    rebuild
}